 <template>
  <v-layout row wrap>
    <v-card class="pa-2">
      <v-card-title class="grey lighten-2" primary-title>
        Matched Detail
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.journal }}</v-subheader>
                <span class="queryValue">{{ matchDet.journal }}</span>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.acctNo }}</v-subheader>
                <div class="queryValue" v-for="item in filterAcctNoList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.matchedDate }}</v-subheader>
                <span class="queryValue">{{ matchDet.matchedDate }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDet.baseTranReceiptLbl }}</v-subheader>
                <span class="queryValue">{{ matchDet.baseTranReceipt }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.contBranch }}</v-subheader>
                <span class="queryValue">{{ filterBranchList(matchDet.contBranch) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDet.selTranPaymentLbl }}</v-subheader>
                <span class="queryValue">{{ matchDet.selTranPayment }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.branch }}</v-subheader>
                <span class="queryValue">{{ filterBranchList(matchDet.branch) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.matchedAmt }}</v-subheader>
                <span class="queryValue">{{ matchDet.matchedAmt }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.matchedLocAmt }}</v-subheader>
                <span class="queryValue">{{ matchDet.matchedLocAmt }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ matchDetLabel.createdBy }}</v-subheader>
                <span class="queryValue">{{ matchDet.createdBy }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-checkbox color="primary" :label="matchDetLabel.mchListPrtd" v-model="matchDet.mchListPrtd" readonly/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'

export default {
  data() {
    return {
      showMatchDetail: false,
      matchDetLabel: {
        journal: 'Journal',
        acctNo: 'Account No.',
        matchedDate: 'Matched Date',
        baseTranReceipt: 'Base Transaction is Receipt',
        contBranch: 'Branch',
        selTranPayment: 'Selected Transaction is Payment',
        branch: 'Branch',
        matchedAmt: 'Matched Amount',
        matchedLocAmt: 'Matched Local Amount',
        createdBy: 'Created by',
        mchListPrtd: 'Matched List Printed'
      },
      allbranches: [],
      accountnos: []
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.loadDetail()
      }
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      this.fetchAccount()
      this.fetchBranch()
      this.fetchMatchData(this.objData)
    },
    closeDialog() {
      this.$emit('close')
    },
    disabledMatch() {
      if (this.objData.netAmount !== this.objData.localOutstandingBalance) {
        return false
      } else {
        return true
      }
    },
    filterBranchList(value) {
      const branch = this.allbranches.find(list =>
        list.value === value
      )
      return branch ? branch.label : ''
    }
  },
  computed: {
    filterAcctNoList() {
      return this.accountnos.filter((list) => {
        return list.value === this.matchDet.acctNo
      })
    }
  },
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    objData: {
      type: Object,
      default: null
    }
  },
  mixins: [TableConst.default, accountsAjaxCalls, accountsFilters, accountsViewMixin]
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
